module.exports = function() {
  return new Worker(__webpack_public_path__ + "8ec8db038fbded96d845.worker.js");
};